import(/* webpackMode: "eager" */ "/app/app/service-pour-les-professionnels/page.tsx");
